export default __webpack_public_path__ + "static/media/soaratName.45b50f68.svg";